module.exports = __webpack_public_path__ + "img/clock.c8d484bc.png";